// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import WorkFormContainer from 'modules/onBoarding/components/Work'

const WorkDetails = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 2 - Work | ATD`}>
      <WorkFormContainer />
    </DocumentTitle>
  )
}

export default WorkDetails
